import PropTypes from 'prop-types'
import { Page, Container, ContentHeader, LoadingFeedback } from 'components'

import { useFetch } from 'hooks'
import * as service from 'service'
import { routes } from 'Routes'

import { ChurnReasonForm } from './components'

const ChurnReasonsEdit = ({ match }) => {
  const {
    params: { churnReasonId },
  } = match

  const { response, isLoading } = useFetch(
    service.dponet.churnReasons.show,
    { churnReasonId },
    [],
  )

  const churnReason = response?.data?.churnReason

  const navigationsRoutes = [
    {
      text: 'Listagem',
      route: routes.churnReasons.all,
    },
  ]

  return (
    <Page title="Edição de motivo de churn">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          title="Edição"
          menu="Motivos de churn"
          subtitle="Edição de motivo de churn"
          menuNavigations={navigationsRoutes}
        />
        {!isLoading && <ChurnReasonForm isEdit churnReason={churnReason} />}
      </Container>
    </Page>
  )
}

ChurnReasonsEdit.propTypes = {
  match: PropTypes.object,
}

export default ChurnReasonsEdit
